// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

::-webkit-scrollbar-track {
  box-shadow: inset 5px 5px 5px #ebf1f5;
  border-radius: 10px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 12px;
  margin: 5px;
  display: none;
}

::-webkit-scrollbar-thumb {
  background-color: #a8a8ba;
  border-radius: 6px;

}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* .sticky-column {
  position: sticky;
  right: 0;
  background: white; 
  z-index: 1; 
  box-shadow: -1px 0 0 #ddd; 
} */
.graph {
  height: 400px !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;;AAEpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;;;GAMG;AACH;EACE,wBAAwB;AAC1B","sourcesContent":[".App {\n  text-align: center;\n}\n\n::-webkit-scrollbar-track {\n  box-shadow: inset 5px 5px 5px #ebf1f5;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 12px;\n  margin: 5px;\n  display: none;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #a8a8ba;\n  border-radius: 6px;\n\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* .sticky-column {\n  position: sticky;\n  right: 0;\n  background: white; \n  z-index: 1; \n  box-shadow: -1px 0 0 #ddd; \n} */\n.graph {\n  height: 400px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
